<template>
  <form-panel
    width="short"
    title="Asunto"
    @closePanel="onClose">
    <div class="main-subject padding-20">
      <el-form
        ref="FormSubject"
        :model="model"
        :rules="rules"
        label-position="top">
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="Asunto"
              prop="subject">
              <el-input v-model.trim="model.subject"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-button
              type="primary"
              @click="sendSubject">
              Guardar
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </form-panel>
</template>

<script>
import SubjectModel from '@/models/campaigns/campaign-subject-model'
import FormPanel from '@/components/_shared/form-panel'
export default {
  name: 'CampaignSubjectPanel',
  components: {
    FormPanel
  },
  props: {
    message: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      model: SubjectModel.model(),
      rules: SubjectModel.rules()
    }
  },
  mounted () {
    if (this.message !== {}) {
      this.model.subject = this.message.subject
    }
  },
  methods: {
    onClose () {
      this.$store.dispatch('app/toggleCampaignSubjectPanel')
    },
    sendSubject () {
      this.$refs['FormSubject'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('app/toggleCampaignSubjectPanel')
          this.$emit('sendSubject', this.model)
          this.$message.success('El asunto se asignó con exito')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .main-subject{
    .el-button{
      width: 100%;
      background-color: $primary;
      color: #ffffff;
      box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-subject-panel.vue